import React, { useState } from 'react'
import { Row, Col, Pagination, Form } from "react-bootstrap";
import   './CustomPagination.css'
export default function CustomPagination({
  currentPage,
  totalPages,
  setCurrentPage,
}) {

  return (
    <Row className="my-5 align-items-center pagination_container">

      <Col md={6}>
        <Pagination className="mb-0">

          <Pagination.Prev
            onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
          />

          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage} // ✅ هنا التعديل
              onClick={() => setCurrentPage(i + 1)} // ✅ بدل activePage
            >
              {i + 1}
            </Pagination.Item>
          ))}

          <Pagination.Next
            onClick={() =>
              setCurrentPage((p) => Math.min(p + 1, totalPages))
            }
          />

        </Pagination>
      </Col>

    </Row>
  );
}